var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.715V30.285C39 35.745 35.745 39 30.285 39H17.715C15.48 39 13.62 38.46 12.195 37.425C11.565 36.99 11.01 36.435 10.575 35.805C9.54 34.38 9 32.52 9 30.285V17.715C9 12.255 12.255 9 17.715 9H30.285C32.52 9 34.38 9.54 35.805 10.575C36.435 11.01 36.99 11.565 37.425 12.195C38.46 13.62 39 15.48 39 17.715Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4252 12.1942L12.1952 37.4242C11.5652 36.9892 11.0102 36.4342 10.5752 35.8042L35.8052 10.5742C36.4352 11.0092 36.9902 11.5642 37.4252 12.1942Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 28.125H31.215V25.5C31.215 24.885 30.705 24.375 30.09 24.375C29.475 24.375 28.965 24.885 28.965 25.5V28.125H26.25C25.635 28.125 25.125 28.635 25.125 29.25C25.125 29.865 25.635 30.375 26.25 30.375H28.965V33C28.965 33.615 29.475 34.125 30.09 34.125C30.705 34.125 31.215 33.615 31.215 33V30.375H33.75C34.365 30.375 34.875 29.865 34.875 29.25C34.875 28.635 34.365 28.125 33.75 28.125Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18.375H14.25C13.635 18.375 13.125 17.865 13.125 17.25C13.125 16.635 13.635 16.125 14.25 16.125H21.75C22.365 16.125 22.875 16.635 22.875 17.25C22.875 17.865 22.365 18.375 21.75 18.375Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputing);
export default __webpack_public_path__ + "static/media/computing.b704ac2ad9404ad9cd2f4c22c312d672.svg";
export { ForwardRef as ReactComponent };